import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";

@Component({
  selector: "discussion-feed-nav-tabs",
  templateUrl: "./discussion-feed-nav-tabs.component.html",
  styleUrls: [
    "./discussion-feed-nav-tabs.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DiscussionFeedNavTabsComponent implements OnInit {
  public yourFeed: HTMLElement;
  public globalFeed: HTMLElement;

  constructor() {}

  @Input() type: string;
  @Input() tag: string;
  @Input() discussionSearchTerm: string;
  @Output() setListTo = new EventEmitter<any>();

  ngOnInit() {
    this.yourFeed = document.getElementById("yourFeed");
    this.globalFeed = document.getElementById("globalFeed");
  }

  public setListType(e: HTMLElement) {
    const tokenListArray = Array.from(e.classList);

    // check if yourFeed tab was clicked
    if (tokenListArray.includes("yourFeed") === true) {
      this.setListTo.emit("AllDiscussionsFollowFeed");
    }

    // check if yourFeed tab was clicked
    if (tokenListArray.includes("globalFeed") === true) {
      this.setListTo.emit("AllDiscussionsLatestFeed");
    }
  }
}
